import styled from "styled-components";
import Button from "../Button/Button";

const IconButton = styled(Button)``;

export default IconButton;
